const smartAppBanner = function () {

    const showAppBanner = function (appBanner) {
        const appLink =  document.querySelectorAll('.openAppLink');
        let expiration = appBanner.dataset.expiration;
        let appLinkBtn;
        appBanner.classList.remove('hide');
        TINK.setCookie('androidAppBannerActive', true);
        document.body.classList.add('app-banner-active');
        appBanner.setAttribute('aria-hidden', 'false');
        pushEventSmartApp(true);

        const closeAppBanner = function () {
            TINK.setCookie('androidAppBannerActive', false, expiration);
            document.body.classList.remove('app-banner-active');
            appBanner.classList.add('hide');
            appBanner.setAttribute('aria-hidden', 'true');
        };

        for (let i = 0; i < appLink.length; i++) {
            appLink[i].addEventListener('click', function(e) {
                appLinkBtn = e.target.dataset.appUrl;
                window.open(appLinkBtn, '_blank');
                closeAppBanner();
                pushEventSmartApp(false, 'download');
            });
        }
        document.getElementById('hideAppBanner').addEventListener('click', function () {
            closeAppBanner();
            pushEventSmartApp(false, 'close');
        });
    };

    const displayAppBanner = function (appBanner) {
        if (!TINK.isIosMobile() && TINK.isMobile()) {
            document.querySelector('.forAndroid').classList.remove('hide');
            showAppBanner(appBanner);
        } else if (TINK.isIosMobile() && TINK.isMobile() && !TINK.isSafari()) {
            document.querySelector('.forIos').classList.remove('hide');
            showAppBanner(appBanner);
        }
    };

    //****************************************************************
    // Expose
    //****************************************************************
    return {
        displayAppBanner: displayAppBanner,
    };
}();